/*
 * Copyright 2019 WeBank
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export default {
  register(monaco) {
    monaco.editor.defineTheme('logview', {
      base: 'vs',
      inherit: true,
      rules: [
        { token: 'log-info', foreground: '4b71ca' },
        { token: 'log-error', foreground: 'ff0000', fontStyle: 'bold' },
        { token: 'log-warn', foreground: 'FFA500' },
        { token: 'log-date', foreground: '008800' },
        { token: 'log-normal', foreground: '808080' },
      ],
      colors: {
        'editor.lineHighlightBackground': '#ffffff',
        'editorGutter.background': '#f7f7f7',
      },
    });
  },
};
